import angular from 'angular';
import {
  loaderService,
  orgDataService,
  userService,
} from 'app/services';
import {
  alerts,
  importDocument,
  actionIcon
} from 'app/components/global';
import releaseNote from './releaseNote';
import ReleaseNotesController from './release-notes.controller';
import directive from './release-notes.directive';

export const routeConfig = {
  template: require('./release-notes.html'),
  controller: 'ReleaseNotesController',
  controllerAs: 'releaseNotesVM',
};

export default angular.module('app.components.support.releaseNotes', [
  alerts,
  actionIcon,
  importDocument,
  loaderService,
  orgDataService,
  userService,
  releaseNote
])
  .directive('releaseNotes', directive)
  .controller('ReleaseNotesController', ReleaseNotesController)
  .name;

console.log('app.components.support.releaseNotes created');
